import { useContext, useEffect, useState } from "react";
import API from "./API";
import { ModalContext } from './ModalContext';
import { CurrentUserContextType } from "./interfaces";
import { Link, Route, Routes, useLocation, useNavigate, useParams } from "react-router";
import { NavLink } from "react-router-dom";
import { months } from './global'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserContext } from './UserContext';
import { ContextType, MenuItem } from './interfaces'
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import AdminLevel from "./AdminLevel";
import AdminOpenMonth from "./Modal/AdminOpenMonth";
import PersonMonthReport from "./PersonMonthReport";
import ReportingPerson from "./ReportingPerson";
import { IconName } from '@fortawesome/free-solid-svg-icons';
import ReportingProject from "./ReportingProject";
import ProjectMonthReport from "./ProjectMonthReport";

type FormValues = {
    month: number
}


const menuItems: MenuItem[] = [
    {
        text: 'Pre schvaľovateľov',
        link: 'persons',
        icon: 'list-check',
        visible: (currentUser: CurrentUserContextType) => currentUser.adminLevel >= 1
    }, {
        text: 'Pre projektových manažérov',
        link: 'projects',
        icon: 'list-check',
        visible: (currentUser: CurrentUserContextType) => currentUser.projectManager
    }
]



function Reporting() {

    const location = useLocation();
    const params = useParams();
    let navigate = useNavigate();

    const { currentUser, setCurrentUser } = useContext(UserContext) as ContextType;
    const [showModal, closeModal] = useContext(ModalContext);
    const [loading, setLoading] = useState<boolean>(false)
    const [selectedMenuItem, seSelectedMenuItem] = useState<MenuItem | undefined>()
    const [what, setWhat] = useState<string | undefined>()

    const openMonth = () => {
        return API.openMonth(params.year ?? 0, getValues().month).then(() => {
            //   return getData();
            // reload
        })
    }

    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: {
            month: dayjs().month() + 2
        }
    });


    useEffect(() => {
        let url = params.what;
        if (!params.what) {
            if (currentUser.adminLevel >= 1) {
                url = 'persons'
            } else if (currentUser.projectManager) {
                url = 'projects'
            }
        }
        if (!params.year) {
            const year = dayjs().year()
            navigate('/dashboard/reporting/' + year + '/' + url, { replace: true })
        } else {
            setLoading(true)
        }

        console.log(location);

    }, [params.year])

    if (params.what === 'person') {
        return (
            <div>
                <Routes>
                    <Route path=":month/:personId" element={<PersonMonthReport />} />
                </Routes>
            </div>
        )
    } else if (params.what === 'project') {
        return (
            <div>
                <Routes>
                    <Route path=":month/:projectId" element={<ProjectMonthReport />} />
                </Routes>
            </div>
        )
    }


    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ paddingTop: "13px" }}>
                    <div className="row">
                        <div className="col-5 mt-2">
                            <ul className="nav nav-tabs card-header-tabs">
                                {
                                    menuItems.map(menuItem => {
                                        if (menuItem.visible(currentUser)) {
                                            return (
                                                <li className="nav-item">
                                                    <NavLink className="nav-link" to={"/dashboard/reporting/" + params.year + '/' + menuItem.link}><FontAwesomeIcon fixedWidth icon={["fas", menuItem.icon as IconName]} /> {menuItem.text}</NavLink>
                                                </li>
                                            )
                                        }
                                    })
                                }
                            </ul>
                        </div>
                        <div className="col-4  text-end">
                            {
                                what === 'person' ?
                                    <AdminLevel level={9} match="greaterOrEqual">
                                        <div>
                                            <div className="btn-group" role="group">
                                                <select {...register("month", { valueAsNumber: true })} className="form-select">
                                                    {
                                                        months.map((item, index) => {
                                                            return (
                                                                <option value={index + 1}>{item}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <button className="btn btn-primary" style={{ width: '280px' }} onClick={
                                                    () => showModal(
                                                        <AdminOpenMonth
                                                            confirm={() => openMonth()}
                                                            month={getValues().month}
                                                            year={params.year ? parseInt(params.year, 10) : dayjs().year()}
                                                        />
                                                    )
                                                }>Otvoriť mesiac</button>
                                            </div>
                                        </div>
                                    </AdminLevel>
                                    : null
                            }
                        </div>
                        <div className="col-3  text-end">
                            <div className="btn-group" role="group">
                                <Link className="btn btn-primary" to={"/dashboard/reporting/" + (parseInt(params.year ?? "", 10) - 1) + '/' + what}>&laquo;</Link>
                                <button className="btn btn-primary" style={{ width: '100px' }}>{params.year}</button>
                                <Link className="btn btn-primary" to={"/dashboard/reporting/" + (parseInt(params.year ?? "", 10) + 1) + '/' + what}>&raquo;</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    {
                        params.what === 'persons' ?
                            <ReportingPerson setWhat={setWhat} />
                            : params.what === 'projects' ?
                                <ReportingProject setWhat={setWhat} />
                                : null
                    }
                </div>
            </div>
        </div>
    )
}



export default Reporting;

